export default __webpack_public_path__ + "static/media/avatar-default.a70779f1.png";